module.exports = __webpack_public_path__ + "static/media/trailer_view_light.7319c713.svg";